"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var route_service_1 = require("../core/route.service");
var i18n_service_1 = require("../core/i18n.service");
var user_selection_component_1 = require("./user-selection.component");
var routes = route_service_1.Route.withShell([
    { path: 'user-administration', component: user_selection_component_1.UserAdministrationComponent, data: { title: i18n_service_1.extract('User administration') } }
]);
var UserAdministrationRoutingModule = /** @class */ (function () {
    function UserAdministrationRoutingModule() {
    }
    UserAdministrationRoutingModule = tslib_1.__decorate([
        core_1.NgModule({
            imports: [router_1.RouterModule.forChild(routes)],
            exports: [router_1.RouterModule],
            providers: []
        })
    ], UserAdministrationRoutingModule);
    return UserAdministrationRoutingModule;
}());
exports.UserAdministrationRoutingModule = UserAdministrationRoutingModule;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlci1zZWxlY3Rpb24ucm91dGluZy5tb2R1bGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ1c2VyLXNlbGVjdGlvbi5yb3V0aW5nLm1vZHVsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxzQ0FBeUM7QUFDekMsMENBQXVEO0FBRXZELHVEQUE4QztBQUM5QyxxREFBK0M7QUFDL0MsdUVBQXlFO0FBRXpFLElBQU0sTUFBTSxHQUFXLHFCQUFLLENBQUMsU0FBUyxDQUFDO0lBQ25DLEVBQUMsSUFBSSxFQUFFLHFCQUFxQixFQUFFLFNBQVMsRUFBRSxzREFBMkIsRUFBRSxJQUFJLEVBQUUsRUFBQyxLQUFLLEVBQUUsc0JBQU8sQ0FBQyxxQkFBcUIsQ0FBQyxFQUFDLEVBQUM7Q0FDdkgsQ0FBQyxDQUFDO0FBT0g7SUFBQTtJQUNBLENBQUM7SUFEWSwrQkFBK0I7UUFMM0MsZUFBUSxDQUFDO1lBQ04sT0FBTyxFQUFFLENBQUMscUJBQVksQ0FBQyxRQUFRLENBQUMsTUFBTSxDQUFDLENBQUM7WUFDeEMsT0FBTyxFQUFFLENBQUMscUJBQVksQ0FBQztZQUN2QixTQUFTLEVBQUUsRUFBRTtTQUNoQixDQUFDO09BQ1csK0JBQStCLENBQzNDO0lBQUQsc0NBQUM7Q0FBQSxBQURELElBQ0M7QUFEWSwwRUFBK0IifQ==


//////////////////
// WEBPACK FOOTER
// ./src/app/user-selection/user-selection.routing.module.ts
// module id = 631
// module chunks = 0